import React from 'react';
import propTypes from 'prop-types';
import './style.scss';

function PreviewImage({ item } = {}) {
    if (!item || !item.previewImage) {
        return null;
    }

    const { previewImage } = item;

    return <div className="preview-image" style={{ backgroundImage: `url(${previewImage})` }} />;
}

PreviewImage.propTypes = {
    item: propTypes.object,
};

export default PreviewImage;
